import global from "global";
import { logError } from "../../../../../monitoring";

export default () => {
  try {
    return global.s.getNewRepeat(365);
  } catch (e) {
    logError(e);

    return "";
  }
};
